<template>
    <div>
        <st-divider class="auth-title" :between="3.4">
            스쿨투게더에 로그인해주세요.
        </st-divider>
        <st-divider :between="1.4">
            <st-input
                v-model="password"
                type="password"
                :width="37.5"
                placeholder="비밀번호를 입력해주세요."
                @enter="submitHandler"
                ref="password_input"
            />
        </st-divider>
        <st-divider class="auto-login-checkbox" :between="3">
            <st-checkbox v-model="auto" @change="isCheckedAlertHandler" @enter="submitHandler">
                자동 로그인
            </st-checkbox>
        </st-divider>

        <st-divider :between="4">
            <st-button :width="27.5" color="primary" :disabled="loading" @click="submitHandler">
                로그인하기
            </st-button>
        </st-divider>
        <div class="pw-re-config">
            혹시 비밀번호를 잊으셨나요? <span class="abled-span" @click="reConfigBeforeHandler">비밀번호 재설정</span>
        </div>
    </div>
</template>
<script>
import { dataEncoded } from "../../../utils/lib";

export default {
    name: "AuthPassword",
    data: () => ({
        password: null,
        auto: false,
        loading: false
    }),
    props: {
        phone: String
    },
    methods: {
        isCheckedAlertHandler({ value }) {
            if (value) this.$alert("info", "자동로그인을 설정하셨습니다.");
        },

        loadingToggle() {
            this.loading = !this.loading;
        },

        reConfigBeforeHandler() {
            const data = dataEncoded({ phoneNumber: this.phone });

            this.$confirm(
                {
                    title: "비밀번호 재설정",
                    content: "비밀번호를 재설정하시겠습니까?<br/>* 로그인하실 번호로 인증번호가 갈 예정입니다.",
                    onConfirm: async () => {
                        try {
                            const response = await this.$api.user.makeAuth(data);

                            if (response.data.resultCode === 10001) {
                                this.$emit("push-page", "auth-code");
                                this.$emit("prev-code", "pw-login");
                            }
                        } catch (e) {
                            this.$alert("error", e.message);
                        }
                    }
                },
                {
                    buttonText: {
                        confirm: "예",
                        cancle: "아니오"
                    }
                }
            );
        },

        async submitHandler() {
            if (!this.password) {
                this.$alert("error", "비밀번호를 입력해주세요.");
                return;
            }

            this.loadingToggle();

            try {
                const data = dataEncoded({ phoneNumber: this.phone, password: this.password });
                const response = await this.$api.user.authPassword(data);

                this.$emit("login", { ...response.data, auto: this.auto, hooks: this.loadingToggle });
            } catch (e) {
                this.loadingToggle();
                this.$alert("error", e.message);
            }
        }
    },

    mounted() {
        this.$refs.password_input.focus();
    }
};
</script>
<style lang="scss"></style>
